import { isUnsafeMethod } from '../common/utils/auth/csrf'

import { Method } from './http'
import isPublicAuthRoute from './isPublicAuthRoute'

type PortalRequestPolicyArgs = {
    cookieAuthMode: boolean
    method?: Method | string
    url: string
}

const normalizePortalRequestPath = (url: string): string => {
    const pathname = new URL(url, window.location.origin).pathname
    return pathname.replace(/^\/(?:admin|partner|support|userapp)\/api(?=\/)/, '').replace(/^\/api(?=\/)/, '')
}

const isPortalSessionBootstrapRoute = (url: string): boolean => normalizePortalRequestPath(url) === '/auth/current'

// Decide whether an unsafe portal request should bootstrap and attach a CSRF header.
export const shouldAttachPortalCsrf = ({ cookieAuthMode, method, url }: PortalRequestPolicyArgs): boolean =>
    cookieAuthMode && isUnsafeMethod(method) && !isPublicAuthRoute(url)

// Decide whether a failed portal request should retry once after forcing a fresh CSRF handshake.
export const shouldRetryPortalRequestWithFreshCsrf = ({
    cookieAuthMode,
    method,
    url,
    status,
}: PortalRequestPolicyArgs & { status?: number | string }): boolean =>
    shouldAttachPortalCsrf({ cookieAuthMode, method, url }) && (status === 400 || status === 403)

// Decide whether a protected request should fail closed by invalidating the hydrated portal session.
export const shouldInvalidatePortalSessionOnUnauthorized = ({
    status,
    url,
}: {
    status?: number | string
    url: string
}) => status === 401 && !isPublicAuthRoute(url) && !isPortalSessionBootstrapRoute(url)
